var exports = {
  "HS": "ChannelMembers.module__groupContainer___c18ybz",
  "x_": "ChannelMembers.module__groupHeader___c18ybz",
  "nF": "ChannelMembers.module__virtualGroupRow___c18ybz",
  "xQ": "ChannelMembers.module__groupHeaderLabel___c18ybz",
  "Px": "ChannelMembers.module__groupHeaderSeparator___c18ybz",
  "gV": "ChannelMembers.module__groupHeaderCount___c18ybz",
  "cr": "ChannelMembers.module__membersList___c18ybz",
  "fL": "ChannelMembers.module__virtualListContent___c18ybz",
  "wt": "ChannelMembers.module__virtualRow___c18ybz",
  "ar": "ChannelMembers.module__virtualMemberRow___c18ybz",
  "CU": "ChannelMembers.module__groupSpacer___c18ybz",
};

module.exports = exports;
